import { Box, StatusMessage, SelectionSet, SelectionSetInput, SelectionSetLabel, SelectionSetTileImageContainer, FluidImage, SelectionSetTileContents, SelectionSetTileName, SelectionSetTilePrice, FlexBox, Button } from '@vp/swan';
import React, { useContext, useState, useEffect } from 'react';
import './src-components-AdvanceMessagingComponent-ProductList-ProductList.styles.scss.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';

const ProductList = ({ items, orderId, sender, isCancellationFlow }) => {
  const {
    state: { sendChatbotMessage }
  } = useContext(ChatbotContext);
  const [selectedValues, setSelectedValues] = useState({});
  const [showConfirmButton, setShowConfirmButton] = useState(false);
  const [showWarningMessage, setShowWarningMessage] = useState(false);
  const handleProductSelect = () => {
    if (sender === "user") return;
    const selectedItems = items.filter((item) => selectedValues[item.itemId]);
    setShowConfirmButton(false);
    if (selectedItems && sendChatbotMessage) {
      sendChatbotMessage({
        type: "product_select",
        messageData: {
          items: selectedItems,
          orderId
        }
      });
    }
  };
  const handleSelectedValuesChange = (e) => {
    if (sender === "user") return;
    setSelectedValues(e);
    let isSelected = false;
    Object.values(e).forEach((value) => {
      if (value) {
        isSelected = true;
      }
    });
    setShowConfirmButton(isSelected);
  };
  useEffect(() => {
    const acc = {};
    items.forEach((item) => {
      acc[item.itemId] = false;
    });
    setSelectedValues(acc);
  }, [items]);
  useEffect(() => {
    if (isCancellationFlow) {
      const hasCancellableItem = items.some((product) => product.is_cancellable === false);
      if (hasCancellableItem) {
        setShowWarningMessage(true);
      }
    }
  }, [items]);
  return /* @__PURE__ */ React.createElement(Box, null, isCancellationFlow && showWarningMessage && /* @__PURE__ */ React.createElement(StatusMessage, { skin: "warning", marginY: "between-actions", style: { paddingTop: "6px" } }, "Cancellation isn\u2019t possible once we start printing your products."), /* @__PURE__ */ React.createElement(
    SelectionSet,
    {
      skin: "tiles-mini",
      variant: "multi-select",
      compactMode: true,
      selectedValues,
      onSelectedValuesChange: handleSelectedValuesChange,
      imageWidth: "fixed",
      className: `product-list ${sender === "user" ? "ca-product-list-user " : ""}`,
      marginY: "between-actions",
      style: sender === "user" ? { cursor: "default" } : {},
      marginTop: "between-actions"
    },
    items.map((item) => /* @__PURE__ */ React.createElement(SelectionSetInput, { value: item.itemId, key: item.itemId, disabled: isCancellationFlow && !item.is_cancellable }, /* @__PURE__ */ React.createElement(SelectionSetLabel, { className: "product-container", style: { marginBottom: "8px" } }, /* @__PURE__ */ React.createElement(SelectionSetTileImageContainer, { className: "product-image-container" }, /* @__PURE__ */ React.createElement(FluidImage, { src: item.imagURL, alt: "placeholder", style: { maxHeight: "60px", maxWidth: "60px" } })), /* @__PURE__ */ React.createElement(SelectionSetTileContents, { className: "product-description" }, /* @__PURE__ */ React.createElement(SelectionSetTileName, null, item.name), /* @__PURE__ */ React.createElement(SelectionSetTilePrice, null, isCancellationFlow ? !item.is_cancellable ? item.status : item.displayPrice : item.displayPrice)))))
  ), showConfirmButton && /* @__PURE__ */ React.createElement(FlexBox, { justifyContent: "space-around", className: "product-list-confirm-button" }, /* @__PURE__ */ React.createElement(Button, { skin: "primary", onClick: handleProductSelect }, "Confirm selection")));
};

export { ProductList as default };
//# sourceMappingURL=src-components-AdvanceMessagingComponent-ProductList-ProductList.js.map
